<mat-grid-list cols="12" rowHeight="55"
               *ngIf="broadcast?.manualData"
               [class.desktop]="isDesktop$ | async"
               [class.tablet]="isTablet$ | async">
  <mat-grid-tile colspan="12">
    <button mat-stroked-button (click)="updateInningPart('F')" [class.selected]="broadcast.manualData.inningPart === 'F'">
      <mat-icon>sports_score</mat-icon>
      Final
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <button mat-stroked-button (click)="updateInningPart('T')" [class.selected]="broadcast.manualData.inningPart === 'T'">
      <mat-icon class="top">play_arrow</mat-icon>
      Top
      <span class="keycode">T</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <button mat-stroked-button (click)="updateInningPart('M')" [class.selected]="broadcast.manualData.inningPart === 'M'">
      <mat-icon>unfold_less</mat-icon>
      Middle
      <span class="keycode">M</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <button mat-stroked-button (click)="updateInningPart('B')" [class.selected]="broadcast.manualData.inningPart === 'B'">
      <mat-icon class="bottom">play_arrow</mat-icon>
      Bottom
      <span class="keycode">B</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <button mat-stroked-button (click)="updateInningPart('E')" [class.selected]="broadcast.manualData.inningPart === 'E'">
      <mat-icon class="end">skip_next</mat-icon>
      End
      <span class="keycode">E</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="4">
    <button mat-stroked-button (click)="updateInning()">
      <mat-icon>table</mat-icon>
      Inning +
      <span class="keycode">I</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="4">
    <button mat-stroked-button (click)="awayRun()">
      <mat-icon>scoreboard</mat-icon>
      Away +
      <span class="keycode">G</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="4">
    <button mat-stroked-button (click)="homeRun()">
      <mat-icon>scoreboard</mat-icon>
      Home +
      <span class="keycode">H</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="4">
    <button mat-stroked-button (click)="updateInning(true)">
      <mat-icon>table</mat-icon>
      Inning -
      <span class="keycode shift">
        <mat-icon>arrow_upward</mat-icon>
        shift
      </span>
      <span class="keycode">I</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="4">
    <button mat-stroked-button (click)="awayRun(-1)">
      <mat-icon>scoreboard</mat-icon>
      Away -
      <span class="keycode shift">
        <mat-icon>arrow_upward</mat-icon>
        shift
      </span>
      <span class="keycode">G</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="4">
    <button mat-stroked-button (click)="homeRun(-1)">
      <mat-icon>scoreboard</mat-icon>
      Home -
      <span class="keycode shift">
        <mat-icon>arrow_upward</mat-icon>
        shift
      </span>
      <span class="keycode">H</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="12" rowspan="2">
    <app-status [broadcast]="broadcast$ | async" [preview]="true" [manual]="true" relatedGamesControlAction="off"></app-status>
  </mat-grid-tile>
  <mat-grid-tile colspan="4">
    <button mat-stroked-button (click)="toggle('third')" [class.selected]="broadcast.manualData.third">
      <mat-icon>directions_run</mat-icon>
      Third
      <span class="keycode arrow">
        <mat-icon>arrow_left</mat-icon>
      </span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="4">
    <button mat-stroked-button (click)="toggle('second')" [class.selected]="broadcast.manualData.second">
      <mat-icon>directions_run</mat-icon>
      Second
      <span class="keycode arrow">
        <mat-icon>arrow_drop_up</mat-icon>
      </span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="4">
    <button mat-stroked-button (click)="toggle('first')" [class.selected]="broadcast.manualData.first">
      <mat-icon>directions_run</mat-icon>
      First
      <span class="keycode arrow">
        <mat-icon>arrow_right</mat-icon>
      </span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <button mat-stroked-button (click)="out()">
      <mat-icon>pin</mat-icon>
      Out
      <span class="keycode">O</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <button mat-stroked-button (click)="undo()">
      <mat-icon>undo</mat-icon>
      Undo
      <span class="keycode">U</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <button mat-stroked-button (click)="sync()">
      <mat-icon>sync</mat-icon>
      Sync
      <span class="keycode">Y</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <button mat-stroked-button (click)="reset()">
      <mat-icon>undo</mat-icon>
      Reset
      <span class="keycode">R</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <button mat-stroked-button (click)="ball()">
      <mat-icon>sports_baseball</mat-icon>
      Ball
      <span class="keycode">A</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <button mat-stroked-button (click)="strike()">
      <mat-icon>sports_baseball</mat-icon>
      Strike
      <span class="keycode">S</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <button mat-stroked-button (click)="foul()">
      <mat-icon>sports_cricket</mat-icon>
      Foul
      <span class="keycode">F</span>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <button mat-stroked-button (click)="inPlay()">
      <mat-icon>sports_cricket</mat-icon>
      In play
      <span class="keycode">P</span>
    </button>
  </mat-grid-tile>
</mat-grid-list>
<mat-grid-list [cols]="(isDesktop$ | async) ? 10 : 5" rowHeight="55" *ngIf="broadcast">
  <mat-grid-tile *ngFor="let speed of range">
    <button mat-stroked-button (click)="setSpeed(speed)" [class.selected]="broadcast.radarSpeed === speed">
      <!--<mat-icon>sports_baseball</mat-icon>-->
      {{speed}}
    </button>
  </mat-grid-tile>
</mat-grid-list>
